(() => {
    'use strict';

    const selectOptions = (widget, notification) => {
        notification.object.selected_options.forEach((bookingOption) => {
            const optionElem = widget.find('.booking-option[data-booking-option-id="' + bookingOption.id + '"]');

            if (optionElem.length === 0) {
                // Booking option is not on display.
                return;
            }

            optionElem.dataAndAttr('number-of-users-who-have-selected', bookingOption.number_of_users_who_have_selected);
            optionElem.dataAndAttr('maximum-number-of-users-who-can-select', bookingOption.maximum_number_of_users_who_can_select);

            const availability = bookingOption.maximum_number_of_users_who_can_select - bookingOption.number_of_users_who_have_selected;
            optionElem.find('.booking-option-availability-count').html(availability);

            optionElem.find('.attendees-wrapper').append(notification.object.avatar);
            updateAvatars(optionElem);

            if (real.events.isFromCurrentUser(notification)) {
                // Authenticated user selected.
                optionElem.addClass('selected');
                if (widget.find('.booking-option.selected').length >= widget.data('select-options-max')) {
                    widget.addClass('authenticated-user-has-selected-max');

                    widget.find('.booking-option:not(.selected)').each(function () {
                        const optionElem = $(this);

                        const selectOptionBtn = optionElem.find('.select-option-btn');
                        selectOptionBtn.addClass('disabled tooltip');
                        selectOptionBtn.attr('title', widget.data('max-selected-msg'));
                    });
                }
            } else if (availability === 0) {
                // This is full now.
                if (!optionElem.is('.selected')) {
                    optionElem.addClass('full');
                }
            }
        });
    };

    const deselectOptions = (widget, notification) => {
        notification.object.deselected_options.forEach((bookingOption) => {
            const optionElem = widget.find('.booking-option[data-booking-option-id="' + bookingOption.id + '"]');
            if (optionElem.length === 0) {
                // Booking option is not on display.
                return;
            }

            optionElem.dataAndAttr('number-of-users-who-have-selected', bookingOption.number_of_users_who_have_selected);
            optionElem.dataAndAttr('maximum-number-of-users-who-can-select', bookingOption.maximum_number_of_users_who_can_select);

            const availability = bookingOption.maximum_number_of_users_who_can_select - bookingOption.number_of_users_who_have_selected;
            optionElem.find('.booking-option-availability-count').html(availability);

            optionElem.find('.avatar[data-user-id="' + notification.actor.user.id + '"]').remove();
            updateAvatars(optionElem);

            if (real.events.isFromCurrentUser(notification)) {
                // Authenticated user canceled.
                optionElem.removeClass('selected');
                if (widget.find('.booking-option.selected').length < widget.data('select-options-max')) {
                    widget.removeClass('authenticated-user-has-selected-max');

                    widget.find('.booking-option:not(.selected)').each(function () {
                        const optionElem = $(this);

                        const selectOptionBtn = optionElem.find('.select-option-btn');
                        selectOptionBtn.removeClass('disabled tooltip');
                        selectOptionBtn.removeAttr('title');
                    });
                }
            } else if (availability > 0) {
                optionElem.removeClass('full');
            }
        });
    };

    real.events.on('booking:answer:created', notification => {
        const widget = $('#widget-' + notification.object.booking.id);
        if (widget.length === 0) {
            // Widget is not on display.
            return;
        }

        selectOptions(widget, notification);

        if (real.events.isFromCurrentUser(notification)) {
            // Authenticated user selected.
            widget.dataAndAttr('answer-id', notification.object.booking_answer.id);
            howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
        }
    });

    real.events.on('booking:answer:deleted', notification => {
        const widget = $('#widget-' + notification.object.booking.id);
        if (widget.length === 0) {
            // Widget is not on display.
            return;
        }

        deselectOptions(widget, notification);

        if (real.events.isFromCurrentUser(notification)) {
            // Authenticated user canceled.
            widget.removeDataAndAttr('answer-id');
            howspace.workspace.page.pathMode.handleUserHasNotInteracted(widget);
        }
    });

    real.events.on('booking:answer:updated', notification => {
        const widget = $('#widget-' + notification.object.booking.id);
        if (widget.length === 0) {
            // Widget is not on display.
            return;
        }

        deselectOptions(widget, notification);

        selectOptions(widget, notification);

        if (real.events.isFromCurrentUser(notification)) {
            // Authenticated user selected.
            widget.dataAndAttr('answer-id', notification.object.booking_answer.id);
        }
    });

    const initWhoHaveAnsweredModal = modal => {
        // Nothing to do here.
    };

    const initEditDefaultEmailModal = (modal, modalOpener) => {
        modal = $(modal);
        const widget = $(modalOpener.closest('.widget-booking'));
        const languageCode = modal.data('language-code');

        modal.find('.save-btn').on('click', () => {
            const dataPayload = real.form.getDataPayload(modal);

            dataPayload.workspace = real.dom.$body.data('workspace-id');
            dataPayload.language_code = languageCode;
            dataPayload.widget = {
                oid: widget.data('widget-id'),
                type: widget.data('widget-type')
            };

            const id = modal.find('#email-id-input').val() || null;
            const url = id ? '/api/defaultemail/' + id : '/api/defaultemails';

            real.ajax.json(real.baseUri + url, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.components.lister.reload($('#' + widget.data('widget-id') + '-default-emails-lister'));
                    howspace.components.modal.close(modal);
                }
            });
        });
    };

    const initConfirmDeleteDefaultEmailModal = (modal, modalOpener) => {
        modal = $(modal);
        modalOpener = $(modalOpener);
        const widget = modalOpener.closest('.widget-booking');

        modal.find('.delete-email-btn').on('click', () => {
            real.ajax.json(real.baseUri + '/api/defaultemail/' + modalOpener.data('email-id'), {
                type: 'DELETE',
                success: () => {
                    howspace.components.lister.reload($('#' + widget.data('widget-id') + '-default-emails-lister'));
                    howspace.components.modal.close(modal);
                }
            });
        });
    };

    const updateAvatars = bookingOption => {
        const avatarContainer = bookingOption.find('.attendees-wrapper');
        let containerWidth = avatarContainer.innerWidth();
        let usedWidth = 0;
        let hiddenCount = 0;

        const moreIndicator = bookingOption.find('.show-attendees-list-btn');
        moreIndicator.text("+0");
        const moreWidth = moreIndicator.outerWidth();

        const avatars = bookingOption.find('.avatar');
        avatars.each(function () {
            const avatar = $(this);
            usedWidth += avatar.outerWidth() + 8;
            if (usedWidth+moreWidth > containerWidth) {
                avatar.hide();
                hiddenCount++;
            } else {
                avatar.show();
            }
        });

        if (hiddenCount > 0) {
            moreIndicator.text(`+${hiddenCount}`).show();
        } else {
            moreIndicator.hide();
        }
    };

    howspace.widgets.booking = {
        initView: (widget, readyFn) => {
            if (typeof readyFn === 'function') {
                readyFn(widget);
            }

            widget.on('click', '.select-option-btn:not(.disabled)', e => {
                const btn = $(e.target);

                real.button.loading(btn, widget);

                let url = howspace.widgets.getApiUrl(widget);
                if (widget.data('answer-id')) {
                    url += '/bookinganswer/' + widget.data('answer-id');
                } else {
                    url += '/bookinganswers';
                }

                real.ajax.json(url, {
                    type: 'POST',
                    data: JSON.stringify({ select_option: btn.closest('.booking-option').data('booking-option-id') }),
                    success: () => {
                        real.button.reset(btn, widget);
                    },
                    error: () => {
                        real.button.reset(btn, widget);
                    }
                });
            });

            widget.find('.cancel-booking-btn').on('click', e => {
                const btn = $(e.target);
                const optionId = btn.closest('.booking-option').data('booking-option-id');

                real.button.loading(btn);

                const url = howspace.widgets.getApiUrl(widget) + '/bookinganswer/' + widget.data('answer-id');

                if (widget.find('.booking-option.selected').length <= 1) {
                    real.ajax.json(url, {
                        type: 'DELETE',
                        success: () => {
                            real.button.reset(btn);
                        },
                        error: () => {
                            real.button.reset(btn);
                        }
                    });
                    return;
                }

                real.ajax.json(url, {
                    type: 'POST',
                    data: JSON.stringify({ deselect_option: optionId }),
                    success: () => {
                        real.button.reset(btn);
                    },
                    error: () => {
                        real.button.reset(btn, widget);
                    }
                });
            });

            if (widget.data('show-attendees')) {
                widget.find('.booking-option').each(function () {
                    const bookingOption = $(this);
                    const avatarContainer = bookingOption.find('.attendees-wrapper');

                    const observer = new ResizeObserver(() => {
                        updateAvatars(bookingOption);
                    });

                    observer.observe(avatarContainer[0]);

                    updateAvatars(bookingOption);
                });
            }
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: (widget, readyFn) => {
            if (typeof readyFn === 'function') {
                readyFn(widget);
            }

            const enableSaveBtn = () => {
                let isSaveBtnDisabled = false;
                widget.find('.options .option:not(.deleted)').each(function () {
                    const optionPayload = real.form.getDataPayload($(this));

                    if (optionPayload.begin_time && optionPayload.end_time) {
                        if (optionPayload.begin_time > optionPayload.end_time) {
                            isSaveBtnDisabled = true;
                        }
                    }
                });

                widget.find('.save-widget-btn').prop('disabled', isSaveBtnDisabled);
            };

            widget.find('.add-booking-option-btn').on('click', () => {
                const itemObject = {
                    start_date_picker_id: howspace.generateRandomStr(12),
                    end_date_picker_id: howspace.generateRandomStr(12)
                };
                const newOption =  howspace.components.sortableList.addItem(widget.find('.howspace-sortable-list'), itemObject);
                howspace.components.card.setId(newOption);
            });

            widget.on(howspace.components.sortableList.ITEM_ADDED, e => {
                const option = $(e.detail.item);
                if (option.length === 0) {
                    return;
                }
                option.find('.dates-wrapper')
                    .toggleClass('d-none', !widget.find('input[data-name="show_date_and_time_in_options"').is(':checked'));
            });

            widget.find('input[data-name="show_date_and_time_in_options"').on('change', e => {
                const input = $(e.target);
                const showDateAndTime = input.is(':checked');
                widget.find('.options .option').each(function () {
                    const option = $(this);
                    option.find('.dates-wrapper').toggleClass('d-none', !showDateAndTime);
                });
            });

            if (widget.find('.option').length === 0) {
                widget.find('.add-booking-option-btn').trigger('click');
            }

            widget.on(howspace.components.datePicker.DATE_COMPARED_FAILED, () => {
                enableSaveBtn();
            });

            widget.on(howspace.components.datePicker.DATE_COMPARED_PASSED, () => {
                enableSaveBtn();
            });

            widget.on(howspace.components.datePicker.DATE_PICKER_CLEARED, () => {
                enableSaveBtn();
            });

        },
        destroyEdit: widget => {
        },
        save: (widget, dataPayload) => {
            dataPayload.booking_options = [];
            widget.find('.options .option:not(.deleted)').each(function () {
                dataPayload.booking_options.push(real.form.getDataPayload($(this)));
            });
            return dataPayload;
        },
        export: (widget, dataPayload) => {
            dataPayload.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return dataPayload;
        },
        initWhoHaveAnsweredModal: initWhoHaveAnsweredModal,
        initEditDefaultEmailModal: initEditDefaultEmailModal,
        initConfirmDeleteDefaultEmailModal: initConfirmDeleteDefaultEmailModal
    };

})();
